import { Component, OnInit } from "@angular/core";
import { LocationCollection } from "../location-collections";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { LocationCollectionsService } from "../location-collections.service";

@Component({
    selector: 'app-location-collections',
    templateUrl: './list.component.html',
    styleUrls: [
        './list.component.scss'
    ],
    standalone: false
})
export class LocationCollectionsViewComponent implements OnInit {
  locationCollections: LocationCollection[];
  selectedLocationCollection: LocationCollection;
  loading = false;
  tableConfig = {
    columns: {
      name: {
        title: 'Collection Name'
      },          
      created_at: {
        title: 'Created On',
      }
    },
    
    actions: {
      add: false,
      edit: false,
      delete: false
    }
  };

  titles = Object.keys(this.tableConfig.columns).map(key => this.tableConfig.columns[key].title);
  keys = Object.keys(this.tableConfig.columns)

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private locationCollectionsService: LocationCollectionsService
  ) {  }

  ngOnInit() {
    this.route.data.subscribe((data) => {
      if(!this.locationCollections) {
        this.locationCollections = this.locationCollectionsService.formatData(data.locationCollections);
      }
    });
  }

  public addLocationCollection() {
    this.router.navigate(['/locationCollections', 'create']);
  }

  public onRowSelect(event) {
    this.router.navigate(['/locationCollections', event.data.id, 'locations']);
  }
}